module.exports = __webpack_public_path__ + "img/modelo-en1.f3ffcbf0.png";